import { Colors, Spacing } from '@lichtblick/theme';
import { Box } from '@lichtblick/ui-components';
import type { FC, PropsWithChildren } from 'react';

export const Section: FC<PropsWithChildren & { backgroundColor?: Colors }> = ({
  backgroundColor = Colors.White,
  children,
}) => (
  <Box as="section" backgroundColor={backgroundColor} pyd={Spacing.Xl} pym={Spacing.L}>
    {children}
  </Box>
);
